<template>
    <div class="page-content">
        <div class="section">
            <div class="user-details-and-avatar">
                <div class="user-details">
                    <div class="followers">Followed by
                        <ul>
                            <li>Calvin Siem</li>
                            <li>Travis Doyle</li>
                        </ul>
                    </div>

                    <h1>Camelia Jenssen</h1>

                    <div class="username">@j.camelia</div>

                    <p>I am an avid traveller. Been to places like Italy, Madagascar, Slovakia and Dubai.</p>
                </div>

                <img src="assets/images/avatar2.png" alt="Camelia Jenssen's avatar" class="avatar" />
            </div>

            <div class="followers-count">
                {{ followers }} Followers &bull; {{ following }} Following
            </div>

            <router-link class="blue-btn"
                v-if="isUser"
                v-bind:to="{ name: 'EditProfile' }">Edit Profile</router-link>

            <div class="follow-buttons" v-else>
                <button class="blue-btn"
                    v-if="isFollowing"
                    v-on:click="unfollow">Following</button>
                <button class="blue-btn"
                    v-else
                    v-on:click="follow">Follow</button>
            </div>
        </div>

        <div class="section itineraries">
            <h2>Top Itineraries</h2>

            <div class="itineraries-list">
                <ItineraryItem v-for="n in 5" v-bind:key="n"></ItineraryItem>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Profile',
        props: ['isUser'],
        components: {
            'ItineraryItem': require('./itineraryItem').default
        },
        data: function() {
            return {
                followers: Math.floor(Math.random() * (1000 - 10)) + 10,
                following: Math.floor(Math.random() * (1000 - 10)) + 10,
                isFollowing: false
            }
        },
        beforeCreate: function() {
            let body = document.querySelector('body')
            body.dataset.page = 'profile'
        },
        methods: {
            follow: function() {
                this.isFollowing = true
                this.followers++
            },
            unfollow: function() {
                this.isFollowing = false
                this.followers--
            }
        }
    }
</script>

<style scoped lang="scss">
    .section {
        margin-left: auto;
        margin-right: auto;
        max-width: 780px;

        @media (min-width: $breakpoint + 1) and (max-width: 780px + 30) {
            padding: 0 15px;
        }
    }


    .user-details-and-avatar {
        display: flex;
        justify-content: space-between;
        align-items: center;

        @media all and (max-width: $breakpoint) {
            flex-direction: column;
        }
    }


    .user-details {
        max-width: 420px;

        @media all and (max-width: $breakpoint) {
            margin-top: 10px;
            text-align: center;
            order: 2;
        }
    }


    .followers {
        line-height: 28px;
        font-weight: $medium;
        color: $dark-gray;
    }


    .followers ul,
    .followers li {
        display: inline;
    }

    .followers ul {
        padding-left: 0;
    }

    .followers li:not(:last-child)::after {
        content: ', ';
        display: inline;
    }


    h1 {
        font-size: 40px;

        @media all and (min-width: $breakpoint + 1) {
            text-align: left;
        }

        @media all and (max-width: $breakpoint) {
            font-size: 24px;
        }
    }


    .username {
        font-style: italic;
        font-weight: $heavy;
        color: $accent;

        @media all and (min-width: $breakpoint + 1) {
            margin-top: 7px;
            line-height: 30px;
        }
    }


    .user-details p {

        @media all and (min-width: $breakpoint + 1) {
            line-height: 30px;
            font-size: 20px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 10px;
            line-height: 24px;
            font-size: 16px;
        }
    }


    .avatar {
        border: solid $light-blue;

        @media all and (min-width: $breakpoint + 1) {
            width: 180px;
            height: 180px;
            border-width: 10px;
        }

        @media all and (max-width: $breakpoint) {
            width: 160px;
            height: 160px;
            order: 1;
            border-width: 7px;
        }
    }


    .followers-count {
        line-height: 30px;
        font-weight: $medium;

        @media all and (min-width: $breakpoint + 1) {
            margin-top: 51px;
            font-size: 20px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
            text-align: center;
            font-size: 16px;
        }
    }


    .blue-btn {
        background-color: $light-blue;
        display: block;
        margin-top: 5px;
        padding: 0 25px;
        min-width: 124px;
        width: max-content;
        height: 48px;
        line-height: 48px;
        text-transform: uppercase;
        text-align: center;
        font-weight: $heavy;
        color: $navy;

        @media all and (max-width: $breakpoint) {
            margin-left: auto;
            margin-right: auto;
            width: 100%;
            height: 40px;
            line-height: 40px;
        }
    }


    .itineraries h2 {
        text-align: left;
    }


    .itineraries-list {
        margin-top: 24px;

        @media all and (max-width: $breakpoint) {
            margin-top: 10px;
        }
    }


    .itinerary-item::v-deep {

        @media all and (min-width: $breakpoint + 1) {
            margin-left: 0;
            margin-right: 0;
            width: 100%;
            height: 386px;
        }


        .itinerary__destinations {
            font-weight: $medium;

            @media all and (min-width: $breakpoint + 1) {
                margin-top: 57px;
                font-size: 14px;
            }
        }


        .itinerary__details {

            @media all and (min-width: $breakpoint + 1) {
                margin-top: 56px;
            }
        }


        .flag {

            @media all and (min-width: $breakpoint + 1) {
                width: 31px;
                height: 31px;
            }
        }


        .itinerary__title {

            @media all and (min-width: $breakpoint + 1) {
                margin-top: 8px;
                font-size: 30px;
            }
        }


        .itinerary__subtitle {

            @media all and (min-width: $breakpoint + 1) {
                margin-top: 9px;
                font-size: inherit;
            }
        }


        .itinerary__owner {
            display: none;
        }


        .like-icon {
            margin-right: 8px;
        }
    }
</style>
